import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, filter, switchMap, take} from 'rxjs/operators';
import {AdminService} from './admin.service';


@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  private isAuthenticating = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private adminService: AdminService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('access_token');
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 403) {
        return this.handleRefresh(request, next, error);
      } else {
        return throwError(error);
      }
    }));
  }

  private handleRefresh(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    if (!this.isAuthenticating) {
      // set authenticating to true so that next requests that come in do not make an authenticate request again
      this.isAuthenticating = true;
      // clear previous value
      this.refreshTokenSubject.next(null);
      // check to see if we have a refresh token
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        return this.adminService.refreshTokenLogin(refreshToken).pipe(
          switchMap((response: any) => {
            this.isAuthenticating = false;
            // notify the other calls that are subscribed to this subject
            this.refreshTokenSubject.next(response.access_token);
            this.refreshTokenSubject.complete();
            return next.handle(request.clone({
              setHeaders: {
                Authorization: `Bearer ${response.access_token}`
              }
            }));
          }));
      } else {
        // TODO redirect to login page which we do not have
        this.isAuthenticating = false;
        return throwError(error);
      }
    } else {
      // if we are currently in the authentication process we set a pipe on the subject so that it will be called when the subjects
      // gets the data thus we do not add multiple requests for authentication in case there are more calls that fail because of it
      return this.refreshTokenSubject.pipe(
        // the filter is needed so that the subjects are not called when we have no token
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          }));
        }));
    }
  }
}
